import React, {Component} from "react";

class Footer extends Component{

    render(){
        return (
            <footer id="footer" className="m-has-bg">
                <div className="footer-bg">
                    <div className="footer-inner">

                        <div className="footer-top">
                            <div className="c-container">

                            </div>
                        </div>

                        <div className="footer-bottom">
                            <div className="footer-bottom-inner">
                                <div className="c-container">

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        )
    }
}

export default Footer


// WEBPACK FOOTER //
// ./src/components/footer/FooterTop.js